import React from 'react';
import {IndexRoute, Route} from 'react-router';
import {
  App,
  NotFound,
  Home,
  // issues
  Issues,
  IssueFossilFuels,
  IssueFossilFuelFinanceInsurance,
  IssueDeforestation,
  IssueGenderEquality,
  IssueCivilianFirearms,
  IssuePrisonIndustrialComplex,
  IssueArmsManufacturers,
  IssueTobacco,
  // solutions
  Solutions,
  SolutionOfferSustainability,
  SolutionDefaultSustainability,
  // the data
  Data,
  PlanScorecard,
  RetirementPlanListContainer,
  AssetManagers,
  TargetDateSeries,
  MutualFundsETFs,
  List,
  Compare,
  Company,
  Companies,
  Methodology,
  //
  PlanScorecardRedirect,
  // edu center
  EduCenterHome,
  EduCenterIndividual,
  EduCenterFinRisks,
  EduCenterPlanAdmins,
  FAQs,
  // misc pages
  About,
  Legal,
  // amazon ad campaign 2021
  AmazonStaffLanding,
  AmazonStaffThanks,
  AmazonVanguardLanding,
  AmazonVanguardThanks,
  // comcast ad campaign 2021
  ComcastPetitionLanding,
  ComcastPetitionThanks,
  // AGM ad campaigns 2022
  ResolutionLanding,
  // bonds
  FossilFuelBondsIn401ks,
  FossilFuelBondRisks,
  // redirects
  BondDemoRedirect,
  BondSurveyRedirect,
  BondRedirect,
} from 'containers'

export default (store) => {
  return (
    <Route path="/" component={App}>
      { /* Home (main) route */ }
      <IndexRoute component={Home}/>

      { /* Data routes */ }
      <Route path="/apple" component={PlanScorecardRedirect}/>

      <Route path="/the-data" component={Data}/>
      <Route path="/retirement-plans" component={RetirementPlanListContainer}/>
      <Route path="/retirement-plans/:planId" component={PlanScorecard}/>
      <Route path="/target-date-funds" component={TargetDateSeries}/>
      <Route path="/target-date-funds/:strategyName" component={TargetDateSeries}/>
      <Route path="/asset-managers" component={Home}/> { /* AssetManagers */ } 

      <Route path="/mutual-funds-etfs/:fundLegalName/:ticker/scorecard/:fundId/:investmentVehicleId" component={MutualFundsETFs}/>
      <Route path="/mutual-funds-etfs" component={List}/>
      <Route path="/compare" component={Compare}/>

      <Route path="/companies/:shortName/:companyId" component={Company}/>
      <Route path="/companies" component={Companies}/>

      { /* Static page routes */ }
      <Route path="/action-center" component={EduCenterHome}/>
      <Route path="/action-center/financial-risks" component={EduCenterFinRisks}/>
      <Route path="/action-center/employees" component={EduCenterIndividual}/>
      <Route path="/action-center/plan-administrators" component={EduCenterPlanAdmins}/>
      <Route path="/action-center/faqs" component={FAQs}/>

      <Route path="/the-issues" component={Issues}/>
      <Route path="/the-issues/fossil-fuels" component={IssueFossilFuels}/>
      <Route path="/the-issues/fossil-fuel-finance-insurance" component={IssueFossilFuelFinanceInsurance}/>
      <Route path="/the-issues/deforestation" component={IssueDeforestation}/>
      <Route path="/the-issues/gender-equality" component={IssueGenderEquality}/>
      <Route path="/the-issues/civilian-firearms" component={IssueCivilianFirearms}/>
      <Route path="/the-issues/prison-industrial-complex" component={IssuePrisonIndustrialComplex}/>
      <Route path="/the-issues/arms-manufacturers" component={IssueArmsManufacturers}/>
      <Route path="/the-issues/tobacco" component={IssueTobacco}/>

      <Route path="/the-solutions" component={Solutions}/>
      <Route path="/the-solutions/offer-sustainability" component={SolutionOfferSustainability}/>
      <Route path="/the-solutions/default-sustainability" component={SolutionDefaultSustainability}/>

      <Route path="/methodology" component={Methodology}/>
      <Route path="/about" component={About}/>
      <Route path="/legal" component={Legal}/>

      <Route path="/amazon" component={AmazonStaffLanding}/>
      <Route path="/amazon-thanks" component={AmazonStaffThanks}/>
      <Route path="/amazon-vanguard" component={AmazonVanguardLanding}/>
      <Route path="/amazon-vanguard-thanks" component={AmazonVanguardThanks}/>

      <Route path="/comcast" component={ComcastPetitionLanding}/>
      <Route path="/comcast-thanks" component={ComcastPetitionThanks}/>

      <Route path="/shareholder-resolution/:planId" component={ResolutionLanding}/>

      <Route path="/fossil-fuel-bonds-in-401ks" component={FossilFuelBondsIn401ks}/>
      <Route path="/financial-risks-fossil-fuel-bonds" component={FossilFuelBondRisks}/>

      { /* Redirects */ }
      <Route path="/bond-demo" component={BondDemoRedirect}/>
      <Route path="/bond-survey" component={BondSurveyRedirect}/>
      <Route path="/bonds" component={BondRedirect}/>

      { /* Catch all route */ }
      <Route path="*" component={NotFound} status={404} />

    </Route>
  );
};
